import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
var Controls = styled.div.withConfig({
  displayName: "Controls",
  componentId: "sc-u0y3in-0"
})(["display:flex;padding-top:14px;> *{width:50%;}", ";"], maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    height: 60px;\n    margin-bottom: 120px;\n  "]))));
var Restore = styled.div.withConfig({
  displayName: "Controls__Restore",
  componentId: "sc-u0y3in-1"
})(["padding:6px 0;border:none;color:", ";text-align:left;font-size:0.8rem;font-weight:500;cursor:pointer;", " ", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.uiDDD;
}, function (_ref2) {
  var active = _ref2.active;
  return active && "\n    display: block;\n  ";
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled && "\n    opacity: 0.6;\n    cursor: no-drop;\n  ";
});
export { Controls, Restore };